import React from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';

import DuetLandingPage from '../../js/duet/DuetLandingPage';
import Duet from '../../../server/services/duet';
import User from '../../../server/services/users';
import UserProfile from '../../../server/models/user_profile';
import {MAX_REJOIN_TIME, MAX_FEEDBACK_TIME} from '../../../lib/constants/duet';

const Page = (props) => <DuetLandingPage {...props} />;
Page.getLayout = (page) => page;

export async function getServerSideProps({req}) {
  const nextMatchTimes = Duet.getNextMatchTimes();
  const profile = req.user && await UserProfile.get(req.user.id);
  const aiPracticeQuestions = await Duet.getAIPracticeQuestions(profile);
  const pendingRequestsByType = await Duet.getPendingRequestsByType();
  let upcomingRequests = [];
  let prevSessions = [];
  let inProgressSession = null;
  let freePeerSessions = null;
  let freeAISessions = null;

  if (req.user) {
    // Check if user has an in-progress or recently completed scheduled
    // session. Allow them to rejoin or redirect to feedback accordingly
    // TODO: Display in progress on demand sessions?
    const latestMatch = await Duet.getLatestMatch(req.user.id);
    if (latestMatch && _.isEmpty(latestMatch.feedback)) {
      const lastMatchTime = moment(latestMatch.match_time);
      const timeDiff = moment().diff(lastMatchTime, 'minutes');
      if (timeDiff < MAX_REJOIN_TIME) {
        const partner = User.makePublicFacing(await User.getByID(latestMatch.user_2));
        inProgressSession = {...latestMatch, partner};
      }
      // TODO: Temporarily disable redirect to feedback page while we fix this issue: https://team-exponent.slack.com/archives/C01HRR498DR/p1737931080341679
      // otherwise, users can get stuck in infinite redirect loop
      // } else if (timeDiff < MAX_FEEDBACK_TIME) {
      //   return {
      //     redirect: {
      //       destination: `/practice/feedback/${latestMatch.room}`,
      //       permanent: false,
      //     },
      //   };
      // }
    }

    upcomingRequests = await Duet.getUpcomingRequests(req.user.id);
    prevSessions = await Duet.getPrevSessions(req.user);
    freePeerSessions = await Duet.getSessionBalance(req.user);
    freeAISessions = await Duet.getAISessionBalance(req.user);
  }

  return {
    props: {
      nextMatchTimes,
      upcomingRequests: JSON.parse(JSON.stringify(upcomingRequests)),
      prevSessions: JSON.parse(JSON.stringify(prevSessions)),
      inProgressSession: JSON.parse(JSON.stringify(inProgressSession)),
      freePeerSessions,
      freeAISessions,
      aiPracticeQuestions,
      pendingRequestsByType: JSON.parse(JSON.stringify(pendingRequestsByType)),
    },
  };
}

export default Page;
